import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  serverURL = environment.serverUrl
  public profileIconName$=new Subject<null>();
  constructor(private http: HttpClient) { }

  forgotPassword(body) {
    return this.http.post(`${this.serverURL}v2/in-site/admin/null/client/password`, body)
  }
  changePassword(body) {
    return this.http.post(`${this.serverURL}v2/in-site/admin/null/client/password/update`, body)
  }
  login(loginModel: { username: string, password: string, recaptchaToken: string }) {
    const httpOptions = {

      // withCredentials: true
    };
    return this.http.post(`${this.serverURL}v2/in-site/admin/null/client/login`, loginModel,httpOptions)
  }
  setProfileName(name){
     this.profileIconName$.next(name);
  }
  public isAuthenticated(): boolean {
		try {
			const token = localStorage.getItem("token");
			// return this.jwtHelperService.isTokenExpired(token);
			const expiry = JSON.parse(atob(token.split(".")[1])).exp;
			return Math.floor(new Date().getTime() / 1000) >= expiry ? false : true;
		} catch (err) {
			return false;
		}

		// return this.jwtHelper.isTokenExpired(token)
	}
}
